// Imports
import Axios from 'axios'

const prodBaseURL = 'https://api.lens.foreplay.co'
// Axios Config
const AxiosConfig = Axios.create({
  // baseURL: 'http://localhost:3000'
  baseURL: prodBaseURL
})

export default AxiosConfig
